import {
  httpClient,
  apiRoutes,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type { ProgressesSubscriptionResponse } from './types';

export const getProgressesSubscriptionListFn = async () => {
  const response = await httpClient.get<ProgressesSubscriptionResponse>(
    `${apiRoutes.subscription.progresses_subscription_list}`
  );
  return response.data;
};

export const useGetProgressesSubscriptionList = (
  opts?: Omit<
    UseQueryOptions<ProgressesSubscriptionResponse, DefaultQueryError>,
    'queryKey'
  >
) =>
  useQuery<ProgressesSubscriptionResponse, DefaultQueryError>({
    queryKey: [apiRoutes.subscription.progresses_subscription_list],
    queryFn: () => getProgressesSubscriptionListFn(),
    ...opts,
  });
